(()=>{
  document.addEventListener("DOMContentLoaded", ()=>{
    // this is the main content holder of the customer portal.
    const rechargeTe = document.querySelector("#recharge-te");
    let MODAL_OPEN = false; // a flag to determine if the modal is open or not
    if(rechargeTe){
      const teModal = rechargeTe.querySelector("#te-modal");
      if(!teModal) return; // can't find it? move on.
      const teModalContent = teModal.querySelector("#te-modal-content");
      if(!teModalContent) return; // can't find it, move on.

      const contentObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if(mutation.type === "childList" && mutation.addedNodes.length) {
            mutation.addedNodes.forEach(addedNode => {
              if(addedNode.nodeType === Node.ELEMENT_NODE && addedNode.classList.contains("rc_add_product_details_container")) {
                const form = addedNode; // If the addedNode is of the class, assign it to form
                console.log("Form added: ", form);

                const selectors = Array.from(form.querySelectorAll(".rc_option__selector"));
                selectors.forEach(selector => {
                  const options = Array.from(selector.options);
                  options.forEach(option => {
                    if(option.textContent.includes("Mini")) {
                      console.log("Removed Mini option");
                      // Remove the Mini option element
                      option.remove();
                    }
                  });
                });
              }
            });
          }
        });
      });


      const modalObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (teModal.classList.contains("visible")) {
              console.log("recharge modal drawer is visible");
              MODAL_OPEN = true;
              contentObserver.observe(teModalContent, {
                childList: true, // we need to watch childList for changes in the element's content
                subtree: true // observe the changes across the entire subtree of teModalContent
              });
            } else {
              MODAL_OPEN = false;
              // disconnect the observer when the modal is not visible
              contentObserver.disconnect();
            }
          }
        });
      });

      modalObserver.observe(teModal, {
        attributes: true // we need to watch attributes for the class changes
      });
    }
  });
})();
